<template>
  <div class="h-100 position-relative">
    <div v-if="!renderList" class="accordion">
      <LoadingSpinner  :variant="'full-title short transparent'" :display-text="$gettext('Loading customers')" />
    </div>
    <div v-if="renderList" class="accordion" role="tablist" :key="sidemenuKey">
      <div @click="allProjects()" role="button" class="list-title list-projects" :class="[mainProjectClass(), (projectAccordion) ? 'not-collapsed' : 'collapsed']">
        <div class="d-block">{{ $gettext('Active projects') }}</div>
        <font-awesome-icon aria-hidden="true" icon="fa-solid fa-caret-right" class="list-caret" />
        <div class="listitem--time">{{ assignedActiveProjectsHours }}
          <span v-if="totalUnassignedHours" class="inline">
            <span class="mx-2">|</span> <span class="text-unassigned">{{ totalUnassignedHours }} {{ $gettext('unassigned') }}</span>
          </span>
        </div>
      </div>
      <b-collapse id="projects_collapse" v-model="projectAccordion" accordion="hour_project_customer_sidemenu_accordion" role="tabpanel">
        <b-row class="accordion--actions">
          <b-col class="col-12 listitem--add text-center">
            <div role="button" @click="$emit('open-project-modal-mini', false)"><font-awesome-icon aria-hidden="true" icon="fa-solid fa-plus" /> {{ $gettext('Add new project') }}</div>
          </b-col>
        </b-row>
        <b-card-body class="p-0">
          <div style="height: calc(100vh - 400px); overflow-y: auto;">
            <RecycleScroller
              class="vs-scroller"
              ref="vs-scroller-active"
              :items="fullProjectsList"
              :item-size="52"
              key-field="id"
              v-slot="{ item }"
            >
              <div :key="'p_' + item.id" class="item-wrap">
                <div class="starbtn-favorite" :class="[(item.favorite) ? 'favorite' : 'not-favorite']" role="button" @click="toggleFavorite(item)">
                  <font-awesome-icon aria-hidden="true" :icon="(item.favorite) ? 'fa-solid fa-star' : 'fa-regular fa-star'" />
                </div>
                <div @click="selectProject(item, 'projects')" :class="[projectClass(item.id)]" class="listitem listitem--project">
                  <b-row>
                    <b-col class="listitem--name">{{ item.name }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col class="col-7 listitem--subname">{{ item.customer_name }}</b-col>
                    <b-col class="col-5 listitem--time d-flex justify-content-end">
                      <div class="listitem--time--amount">{{ (projectHours[item.id]) ? projectHours[item.id].total : '' }}</div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </RecycleScroller>
          </div>
        </b-card-body>
      </b-collapse>
      <hr>
      <div class="list-title list-customer" v-b-toggle.customer_collapse variant="info">
        {{ $gettext('Customers') }}
        <font-awesome-icon aria-hidden="true" icon="fa-solid fa-caret-right" class="list-caret" />
      </div>
      <b-collapse :visible="isExpandedMain()" id="customer_collapse" accordion="hour_project_customer_sidemenu_accordion" role="tabpanel">
        <b-row class="accordion--actions">
          <b-col class="col-6 search pr-0">
            <b-form-input id="type-search" size="sm" :placeholder="$gettext('Search...')" type="search" v-model="search.filters.search_by_name" />
          </b-col>
          <b-col class="col-6 listitem--add">
            <div role="button" @click="$emit('open-contact-modal', false)"><font-awesome-icon aria-hidden="true" icon="fa-solid fa-plus" /> {{ $gettext('Add new') }}</div>
          </b-col>
        </b-row>
        
        <b-card-body class="p-0">

          <div style="height: 100%; max-height: 100vh; overflow-y: auto;">
            <DynamicScroller
              :items="filteredCustomers"
              :min-item-size="60"
              class="vs-scroller"
              ref="vs-scroller-customers"
            >
              <template v-slot="{ item, index, active }">
                <DynamicScrollerItem
                  :item="item"
                  :active="active"
                  :data-index="index"
                  :size-dependencies="[isExpanded(item)]"
                >
                  <div :key="'c_' + item.id" :ref="'c_' + item.id" class="sublist-wrap">
                    <div @click="selectCustomer(item, 'customers')" class="sublist-title" :class="[clientClass(item.id)]">
                      <b-row>
                        <b-col class="col listitem--name">{{ item.name }}</b-col>
                      </b-row>
                      <b-row>
                        <b-col class="listitem--time d-flex">
                          <div class="listitem--time--amount">{{ (companyHours[item.id]) ? companyHours[item.id].total : '' }}</div>
                        </b-col>
                      </b-row>
                      <font-awesome-icon aria-hidden="true" icon="fa-solid fa-caret-right" class="list-caret" />
                    </div>
                    <b-collapse :visible="isExpanded(item)" :id="'customer_project_collapse_'+item.id" :accordion="'hour_customer_project_sidemenu_accordion'" role="tabpanel">
                      <div v-for="a_project in item.projects" :key="'c_p_' + item.id + '_' + a_project.id" @click="selectProject(a_project, 'customers')" :class="projectClass(a_project.id)" class="item-wrap listitem">
                        <div class="starbtn-favorite" :class="[(a_project.favorite) ? 'favorite' : 'not-favorite']" role="button" @click="toggleFavorite(a_project)">
                          <font-awesome-icon aria-hidden="true" :icon="(a_project.favorite) ? 'fa-solid fa-star' : 'fa-regular fa-star'" />
                        </div>
                        <b-row>
                          <b-col class="listitem--name">{{ a_project.name }}</b-col>
                        </b-row>
                        <b-row>
                          <b-col class="listitem--time d-flex">
                            <div class="listitem--time--amount">{{ (projectHours[a_project.id]) ? projectHours[a_project.id].total : '' }}</div>
                          </b-col>
                        </b-row>
                      </div>
                      <div class="listitem listitem--actions">
                        <b-row>
                          <div class="col listitem--add" @click="$emit('open-project-modal', item.id)" role="button">
                            <font-awesome-icon aria-hidden="true" icon="fa-solid fa-plus" /> {{ $gettext('Add project') }}
                          </div>
                        </b-row>
                      </div>
                    </b-collapse>
                  </div>
                </DynamicScrollerItem>
              </template>
            </DynamicScroller>
          </div>

        </b-card-body>
      </b-collapse>
    </div>
  </div>
  
</template>
<script>
  import { mapGetters } from 'vuex';

  import GekkoButton from "@/components/GekkoButton";
  import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"

  import CustomerService from "@/store/services/customer.service.js";
  import HourService from "@/store/services/hour.service.js";
  import ProjectService from "@/store/services/project.service";

  export default {
    name: "HourCustomerSidemenu",
    components: {
      GekkoButton,
      LoadingSpinner
    },
    props: {
      mutationName: {
        type: String,
        default: ''
      },
    },
    data () {
      return {
        hourText: this.$gettext('h'),
        minuteText: this.$gettext('m'),
        sidemenuKey: 0,
        fetchingData: true,
        customerSearch: '',
        customerList: [],
        customerNextUrl: '',
        projectListFav: [],
        projectListFavAll: [],
        projectListActive: [],
        customerFilters: {
          owner_company: null,
          is_customer: "True",
          extended: "True",
          is_archived: "False",
          remove_archived_projects: "True"
        },
        totalHourFilter: {},
        companyHours: {},
        projectHours: {},
        selected: null,
        selectedCustomer: null,
        projectAccordion: true,
        unassignedAccordion: false,
        renderList: false,
        search: {
          filters: { 
            extended: true,
            contains_project: 'True',
            search_by_name: ''
          },
          debounce: 500,
          count: 0,
          next: false,
          hint: true,
          more: false,
          active: false
        }
      }
    },
    computed: {
      ...mapGetters({ 
        getCompanyId: 'main/getCompanyId'
      }),
      filteredCustomers () {
        // Finding customers
        const notArchivedCustomers = this.customerList.filter( a_customer => !a_customer.is_archived );
        const searchCustomers = notArchivedCustomers.filter( a_customer => a_customer.name.toLocaleLowerCase().includes(this.search.filters.search_by_name.toLocaleLowerCase()) );

        // Finding projects
        notArchivedCustomers.forEach(customer => {
          const found = customer.projects.filter(project => project.name.toLocaleLowerCase().includes(this.search.filters.search_by_name.toLocaleLowerCase()));
          if (found.length > 0 && !searchCustomers.find(item => item.id === customer.id)) searchCustomers.push(customer)
        })

        return (this.search.filters.search_by_name) ? searchCustomers : notArchivedCustomers
      },
      partialProjectsList () {
        return this.projectListFav.concat(this.projectListActive)
      },
      projectListRecent () {
        const allProjects = this.customerList.map(customer => customer.projects).flat()
        let recentProjects = []
        allProjects.forEach(recent => {
          if (!this.partialProjectsList.find(project => project.id === recent.id) && this.hasRecentUse(recent.last_used)) {
            recent.customer_name = this.customerList.find(customer => customer.id === recent.company).name
            recentProjects.push(recent)
          }
        })
        recentProjects.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) // alphabetical order

        return recentProjects
      },
      fullProjectsList () {
        return this.partialProjectsList.concat(this.projectListRecent)
      },
      assignedActiveProjectsHours () {
        let totalAmount = 0
        this.fullProjectsList.forEach(project => {
          if (this.projectHours[project.id]) {
            totalAmount += this.projectHours[project.id].total_raw
          }
        })
        // if (this.projectHours[null]) {
        //   totalAmount += this.projectHours[null].total_raw
        // }
        return this.formatAmount(totalAmount)
      },
      totalUnassignedHours () {
        let totalAmount = 0
        if (this.projectHours[null]) {
          totalAmount += this.projectHours[null].total_raw
        }
        return (totalAmount > 0) ? this.formatAmount(totalAmount) : false
      }
    },
    created () {
      window.addEventListener('scroll', this.getCustomerNextPage);
      this.customerFilters.owner_company = this.getCompanyId
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === this.mutationName && state["hourStore"].notRefreshComponent !== this.$options.name) {
          if(state["hourStore"].refreshComponent === this.$options.name) {
            this.projectListActive = []
            this.projectListFav = []
            this.projectListFavAll = []
            this.sidemenuKey++
            this.getCustomerList(true)
          } else {
            this.filters = state["filterStore"].filter
            this.getTotals(this.filters)
          }
        }
      });
      this.getCustomerList(true);
    },
    beforeDestroy() {
      this.unsubscribe();
      window.removeEventListener('scroll', this.getCustomerNextPage);
    },
    methods: {
      toggleFavorite (project) {
        project.favorite = !project.favorite;
        ProjectService.update(project.id, project).then(() => {
          this.sidemenuKey++
          this.getCustomerList(true)
        })
      },
      formatAmount (amount) {
        return Math.floor(amount) + this.hourText + ' ' + Math.round((amount - Math.floor(amount)) * 60) + this.minuteText
      },
      getCustomerList (firstTime) {
        this.fetchingData = true;
        CustomerService.list(this.customerFilters).then((response) => {
          this.projectListFavAll = []

          this.customerList = response.data;
          this.customerNextUrl = response.data.next;

          this.customerList.forEach((a_customer) => {
            a_customer.projects.forEach((a_project) => {
              if(a_project.favorite){
                a_project.customer_name = a_customer.name;
                this.projectListFavAll.push(a_project);
              }
            })
          })
          
          if (firstTime) {
            this.filters = this.$store.getters["filterStore/getFilter"] || {};
            if(this.filters.activeView){
              this.getTotals(this.filters, firstTime);
            }
          }
          this.fetchingData = false;
        })
      },
      getCustomerNextPage(){
        if (!this.fetchingData && this.customerNextUrl) {
          var loadNewCustomers = this.isInViewport('load_more_button');
          if (loadNewCustomers) {
            this.fetchingData = true;
            CustomerService.listNextPage(this.customerNextUrl).then((response)=>{
              this.customerNextUrl = response.data.next;
              this.customerList = this.customerList.concat(response.data.results);
              
              this.customerList.forEach((a_customer) => {
                a_customer.projects.forEach((a_project) => {
                  if(a_project.favorite){
                    a_project.customer_name = a_customer.name;
                    this.projectListFavAll.push(a_project);
                  }
                })
              })

              this.fetchingData = false;
            })
          }
        }
      },
      isInViewport (element_id) {
        let element = document.getElementById(element_id);
        let rect = element.getBoundingClientRect();
        let html = document.documentElement;
        return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || html.clientHeight) &&
          rect.right <= (window.innerWidth || html.clientWidth)
        );
      },
      updateAmounts (filter) {
        this.getTotals(filter);
      },
      getTotals (filter, firstTime) {
        var hourFilters = {};

        if(this.$store.getters["filterStore/getFilter"].created_by) {
          hourFilters.created_by = this.$store.getters["filterStore/getFilter"].created_by;
        }

        hourFilters.company_profile = this.getCompanyId;
        hourFilters.start_date = filter.start_date;
        hourFilters.end_date = filter.end_date;

        hourFilters.group_by = 'project,project__company_id';
        HourService.getTotalAmount(hourFilters).then((response) => {
          this.projectHours = {}
          this.companyHours = {}
          var projectIds = []

          // Get unique company ids with hours
          const companyIds = [...new Set(response.data.map(project => project.project__company_id))] 

          // Initialize company hours array
          companyIds.forEach(item_id => {
            this.companyHours[item_id] = { total: 0, uninvoiced: 0 }
          });

          // Format all project hours amount 
          // get unique project ids and calculate company amounts
          response.data.forEach((item) => {
            this.projectHours[item.project] = { total: this.formatAmount(item.total), uninvoiced: this.formatAmount(item.uninvoiced), total_raw: item.total }
            projectIds.push(item.project);
            this.companyHours[item.project__company_id].total += item.total
            this.companyHours[item.project__company_id].uninvoiced += item.uninvoiced
          });

          // Format all company hours amount 
          Object.keys(this.companyHours).forEach(company => {
            this.companyHours[company].total = this.formatAmount(this.companyHours[company].total)
            this.companyHours[company].uninvoiced = this.formatAmount(this.companyHours[company].uninvoiced)
          })

          this.renderList = true
          this.projectListActive = []
          this.projectListFav = this.projectListFavAll // resetting favorite projects

          this.projectListFav = this.projectListFav.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) // alphabetical order

          this.customerList.forEach((a_customer) => {
            a_customer.projects.forEach((a_project) => {
              if (projectIds.includes(a_project.id)) {
                a_project.customer_name = a_customer.name;
                if (!a_project.favorite) this.projectListActive.push(a_project)
              }
            })
          })

          this.projectListActive.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)) // alphabetical order

          if (firstTime) {
            // this.scrollToElement()
            this.scrollToElementNEW()
          }
          if(firstTime && this.filters.project){
            this.selected = this.filters.project;
            // get full project and emit to show Invoice Hours button
            // but dont refresh everything -> firstTime = true
            const fullproject = this.fullProjectsList.find(x => x.id === this.selected);
            this.$emit('change', { project: fullproject, firstTime: true })
          } else {
            // set selected to null if project is not on any project list
            // and emit change with firsTime just to hide Invoice Hours button
            const fullproject = this.fullProjectsList.find(x => x.id === this.selected);
            if (!fullproject) {
              this.selected = null
              this.$emit('change', { project: fullproject, firstTime: true })
            }
          }
        })
      },
      // scrollToElement () {
      //   let scrollPerItem = 52.5
      //   let scrollPerItemCusProj = 52.5
      //   let project_idx = 0
      //   let customer_idx = 0
      //   let scrollTargetList = 'actListOs'
      //   if (this.$store.getters['filterStore/getCurrentProject'] && !this.$store.getters['filterStore/getCurrentCustomer']) {
      //     // active projects list
      //     project_idx = this.fullProjectsList.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentProject'])
      //   }
      //   if (this.$store.getters['filterStore/getCurrentCustomer']) {
      //     // customers list
      //     customer_idx = this.filteredCustomers.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentCustomer'])
      //     if (this.$store.getters['filterStore/getCurrentProject'] && customer_idx in this.filteredCustomers) {
      //       project_idx = this.filteredCustomers[customer_idx].projects.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentProject'])
      //     }
      //     scrollPerItem = 47.5
      //     scrollTargetList = 'custListOs'
      //   }
      //   setTimeout(() => {
      //     if (this.$refs[scrollTargetList]) {
      //       const osInstance = this.$refs[scrollTargetList].osInstance();
      //       osInstance.scrollStop().scroll({
      //         y: (customer_idx * scrollPerItem) + (project_idx * scrollPerItemCusProj)
      //       });
      //     }
      //   }, 200);
      // },
      selectProject (project, list){
        this.selected = project.id;
        this.$emit('change', { project: project, list: list })
      },
      selectCustomer (customer, list){
        this.$emit('select-customer', { customer: customer, list: list })
        this.recalculateListHeights()
      },
      recalculateListHeights () {
        document.querySelectorAll('.sublist-wrap').forEach(el => {
          el.classList.add('is-expanded');
        });
      },
      unassignedMenuClass () {
        if(this.$store.getters['filterStore/getUnassigned']) {
          return 'selected';
        }
        return '';
      },
      mainProjectClass () {
        if(!this.$store.getters['filterStore/getUnassigned'] && !this.$store.getters['filterStore/getCurrentProject'] && !this.$store.getters['filterStore/getCurrentCustomer']){
          return 'selected';
        }
        return '';
      },
      projectClass (project_id){
        if(project_id === this.$store.getters['filterStore/getCurrentProject']){
          return 'selected';
        }
        return '';
      },
      clientClass (client_id) {
        if(client_id === this.$store.getters['filterStore/getCurrentCustomer'] && !this.$store.getters['filterStore/getCurrentProject']){
          return 'selected';
        }
        return '';
      },
      unassignedHours () {
        this.selected = null
        this.$emit('change', { unassigned: true })
      },
      allProjects () {
        this.selected = null
        this.$emit('change', { project: null })
        this.projectAccordion = true
      },
      isExpandedMain () {
        let expanded = false
        if((this.$store.getters["filterStore/getCurrentCustomer"] !== null)) {
          this.projectAccordion = false
          expanded = true
        }
        return expanded
      },
      isExpanded (client) {
        return this.$store.getters['filterStore/getCurrentCustomer'] === client.id
      },
      hasRecentUse (date) {
        const period = 30 // days
        const lastUsed = new Date(date)
        const lastPeriod = new Date()
        lastPeriod.setDate(lastPeriod.getDate() - period);
        return lastUsed.getTime() > lastPeriod.getTime()
      },
      scrollToElementNEW () {
        let scrollTargetList = 'vs-scroller-active'
        let target_idx = 0
        if (this.$store.getters['filterStore/getCurrentProject'] && !this.$store.getters['filterStore/getCurrentCustomer']) {
          // active projects list
          target_idx = this.fullProjectsList.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentProject'])
        } else if (this.$store.getters['filterStore/getCurrentCustomer']) {
          // customers list
          target_idx = this.filteredCustomers.findIndex(x => x.id === this.$store.getters['filterStore/getCurrentCustomer'])
          scrollTargetList = 'vs-scroller-customers'
        }
        setTimeout(() => {
          if (this.$refs[scrollTargetList]) {
            this.$refs[scrollTargetList].scrollToItem(target_idx)
          }
        }, 200)
      },
    }
  };
</script>
<style lang="scss">


  .calendar-sidemenu {

    small { 
      line-height: 1rem;
      font-size: 0.75rem;
      text-transform: uppercase;
      color: #6b7280;
      margin-bottom: 5px;
      width: 100%;
      display: block;
    }

    .vs-scroller {
      height: 100%;
    }
  }
  
  .calendar-sidemenu {
    .accordion {
      height: 100%;

      padding: 0.5rem;
      background: #FAFAFA;
      border-radius: $radiusLg;
      border: 1px solid $colorBorderDash;

      .collapse { overflow: hidden; }
      .card-body { box-shadow: inset 0px 6px 10px -10px $colorBorderDash; }

      position: sticky;
      top: 60px;
      height: calc(100vh - 240px)
    }
  }

  /* new auto height scrolling */
  @media(min-width: '768px') {
    .calendar-sidemenu {
      .accordion {
        display: flex;
        flex-direction: column;
        #customer_collapse {
          height: 100%;
          .card-body {
            height: 100%;
          }
        }
      }
    }
  }

  /* dbug */
  // .calendar-sidemenu {
  //   outline: 1px solid black;
  //   background: red;
  //   .accordion {
  //     background: blue;
  //     .collapse {
  //       background: lime;
  //       .card-body {
  //         background: green;
  //         .os-host {
  //           background: yellow;
  //         }
  //       }
  //     }
  //   }
  // }

  @media(max-width: '767px') {
    .calendar-sidemenu {
      min-height: auto;
      .collapse {
        max-height: 250px;
        overflow-y: scroll;
        overflow-x: hidden;
      }
    }
  }

</style>
<style lang="scss" scoped>
  .sublist-wrap {
    padding: 1px;
    &.is-expanded {
      margin-bottom: 1px;
    }
  }
  .item-wrap {
    position: relative;
    .starbtn-favorite {
      display: none;
      position: absolute;
      top: 0px;
      right: 10px;
      outline: none;
      border: none;
      background: none;
      padding: 0;
      color: $colorGold;
      font-size: 16px;
      z-index: 10;
      &.favorite {
        display: block;
      }
    }
    &:hover {
      .starbtn-favorite {
        display: block;
      }
    }
  }
  .listitem,
  .sublist-title {
    border-radius: $radiusMd;
    cursor: pointer;
    padding: 5px 7px;
    margin-bottom: 7px;
    position: relative;
    &--name {
      font-size: 16px;
      padding-right: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.2;
    }
    &--subname {
      color: #AFAFAF;
      font-size: 11px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &--time {
      font-family: DINNextLTPro-Regular, sans-serif;
      color: #6C6C6C;
      font-size: 11px;
      height: 12px;
      overflow: hidden;
      transition: height 0.2s ease;
      &--amount {
        width: 45px;
      }
    }
    &--add {
      font-size: 15px;
      color: $colorBlue;
    }
  }

  .listitem:not(.listitem--actions),
  .accordion .sublist-title,
  .accordion .list-title {
    &:hover { background: $colorBlue50; } // #091e4208
    &.selected { 
      background: $colorBlue100;
      box-shadow: $filtersShadow;
    }
  }
  .accordion .sublist-title,
  .accordion .list-title {
    background: transparent;
    outline: none;
  }
   .accordion .list-title {
    background: #f4f4f4; // base unselected bg
  }
  .list-title {
    position: relative;
    font-size: 18px; // 20px
    padding: 10px 7px;
    border-radius: $radiusMd;
    // margin-bottom: 5px;
  }
  .sublist-title {
    position: relative;
    .listitem--name {
      font-size: 16px; // 17px
    }
  }
  .list-title, .sublist-title {
    font-family: DINNextLTPro-Medium, sans-serif;
    line-height: 1.2;
    .list-caret {
      color: $colorBlue;
      font-size: 14px;
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      transition: transform 0.2s ease; 
    }
  }
  .sublist-title {
    .list-caret {
      opacity: 0.5;
      font-size: 12px;
    }
  }
  .list-title {
    &.list-customer {
      padding: 16px 7px; // extra vertical to match list-projects
      .list-caret {
        transform: translateY(-50%) rotate(90deg);
      }
      &.not-collapsed {
        .list-caret {
          transform: translateY(-50%) rotate(-90deg);
        }
      }
    }
  }
  .sublist-title.not-collapsed  {
    .list-caret {
      transform: translateY(-50%) rotate(90deg);
    }
  }
  .sublist-title.not-collapsed {
    .listitem--time {
      height: 0px;
    }
  }
  .accordion {
    hr { margin: 0.5rem 0; }
    &--actions {
      padding: 10px 7px;
      // padding-top: 5px;
      display: flex; 
      align-items: center;
    }
    .collapse {
      position: relative;
      .collapse {
        margin-left: 10px;
        border-left: 1px solid $colorBlue100;
        padding-right: 1px; // for selected shadow
        padding-top: 1px; // for selected shadow
        .listitem { border-radius: 0px $radiusSm $radiusSm 0px; }
      }
    }
  }
  .search {
    input:focus, input:hover {
      border-color: $colorBlue;
      outline: 0;
      box-shadow: none;
    }
    
  }
</style>
